"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsSelectionPopup = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/selection-popup.scss");
var TYPE_OPTIONS = [
    { key: 'metric', text: 'Metric' },
    { key: 'pain', text: 'Pain Point' },
    { key: 'benefit', text: 'Benefit' },
    { key: 'risk', text: 'Risk' },
    { key: 'persona', text: 'Persona' },
    { key: 'tech', text: 'Technology' },
    { key: 'data', text: 'Data Source' },
    { key: 'integration', text: 'Integration' },
    { key: 'budget', text: 'Budget Item' },
    { key: 'roadmap', text: 'Roadmap Item' },
];
var POPUP_WIDTH = 320;
var POPUP_HEIGHT_ESTIMATE = 320;
var VIEWPORT_PADDING = 12;
/**
 * Floating popup anchored at the user's text selection. Lets them
 * tag the snippet as a metric, pain, persona etc and persist a new
 * `ElementMention` (and possibly a new `Element`) on the backend.
 */
var WsSelectionPopup = function (props) {
    var anchor = props.anchor, isSubmitting = props.isSubmitting, onSubmit = props.onSubmit, onDismiss = props.onDismiss;
    var _a = react_1.useState('metric'), elementType = _a[0], setElementType = _a[1];
    var _b = react_1.useState(anchor.text.trim().slice(0, 200)), canonicalName = _b[0], setCanonicalName = _b[1];
    var _c = react_1.useState(''), description = _c[0], setDescription = _c[1];
    var popupRef = react_1.useRef(null);
    // Reset the form when a new selection anchor arrives.
    react_1.useEffect(function () {
        setCanonicalName(anchor.text.trim().slice(0, 200));
        setDescription('');
        setElementType('metric');
    }, [anchor.text, anchor.x, anchor.y]);
    // Dismiss on outside click or Escape — keeps the popup feeling like
    // a tooltip rather than a modal.
    react_1.useEffect(function () {
        var handleClickOutside = function (event) {
            var node = popupRef.current;
            if (node && event.target instanceof Node && !node.contains(event.target)) {
                onDismiss();
            }
        };
        var handleKeydown = function (event) {
            if (event.key === 'Escape') {
                onDismiss();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeydown);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [onDismiss]);
    // Clamp the popup inside the viewport so it never overflows on
    // selections near the right edge / bottom of the page.
    var positionStyle = react_1.useMemo(function () {
        var maxLeft = Math.max(VIEWPORT_PADDING, window.innerWidth - POPUP_WIDTH - VIEWPORT_PADDING);
        var maxTop = Math.max(VIEWPORT_PADDING, window.innerHeight - POPUP_HEIGHT_ESTIMATE - VIEWPORT_PADDING);
        var left = Math.min(Math.max(anchor.x, VIEWPORT_PADDING), maxLeft);
        var top = Math.min(Math.max(anchor.y, VIEWPORT_PADDING), maxTop);
        return { left: left, top: top };
    }, [anchor.x, anchor.y]);
    var dropdownOptions = TYPE_OPTIONS.map(function (opt) { return ({
        key: opt.key,
        text: opt.text,
    }); });
    var handleSave = function () {
        var trimmedName = canonicalName.trim();
        if (!trimmedName) {
            return;
        }
        onSubmit({
            elementType: elementType,
            canonicalName: trimmedName,
            description: description.trim() ? description.trim() : undefined,
        });
    };
    var isSaveDisabled = isSubmitting || canonicalName.trim().length === 0;
    return (react_1.default.createElement("div", { ref: popupRef, className: "ws-ai-hub-selection-popup", style: positionStyle, onMouseDown: function (event) { return event.stopPropagation(); } },
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-header" },
            react_1.default.createElement("span", { className: "ws-ai-hub-selection-popup-title" }, "Add element"),
            react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-selection-popup-close", onClick: onDismiss, "aria-label": "Close" }, "\u00D7")),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-snippet" }, anchor.text),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Type", selectedKey: elementType, options: dropdownOptions, disabled: isSubmitting, onChange: function (_event, option) {
                    if (option) {
                        setElementType(option.key);
                    }
                } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement("label", { htmlFor: "ws-ai-hub-selection-popup-name" }, "Name"),
            react_1.default.createElement("input", { id: "ws-ai-hub-selection-popup-name", type: "text", value: canonicalName, maxLength: 200, disabled: isSubmitting, onChange: function (event) { return setCanonicalName(event.target.value); } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement("label", { htmlFor: "ws-ai-hub-selection-popup-desc" }, "Description (optional)"),
            react_1.default.createElement("textarea", { id: "ws-ai-hub-selection-popup-desc", value: description, maxLength: 4000, disabled: isSubmitting, onChange: function (event) { return setDescription(event.target.value); } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-actions" },
            react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Cancel", onClick: onDismiss, disabled: isSubmitting }),
            react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: isSubmitting ? 'Saving...' : 'Add', onClick: handleSave, disabled: isSaveDisabled }))));
};
exports.WsSelectionPopup = WsSelectionPopup;
